var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBordercruve4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1005_6968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-752.599 5.46153C-740.939 5.46153 -731.463 14.9478 -731.463 26.5989C-731.463 27.9274 -730.391 29 -729.062 29H3.05231C4.38069 29 5.45324 27.9274 5.45324 26.5989C5.45324 14.9478 14.9389 5.46153 26.5991 5.46153C27.9275 5.46153 29 4.38891 29 3.06045V-497.06C29 -498.389 27.9275 -499.462 26.5991 -499.462C14.9389 -499.462 5.45324 -508.948 5.45324 -520.599C5.45324 -521.927 4.38069 -523 3.05231 -523H-729.062C-730.391 -523 -731.463 -521.927 -731.463 -520.599C-731.463 -508.948 -740.939 -499.462 -752.599 -499.462C-753.927 -499.462 -755 -498.389 -755 -497.06V3.06045C-755 4.38891 -753.927 5.46153 -752.599 5.46153ZM-750.198 -494.768C-737.81 -495.909 -727.911 -505.809 -726.769 -518.198H0.759628C1.89121 -505.809 11.7901 -495.909 24.1883 -494.768V0.757771C11.7901 1.89927 1.89121 11.7988 0.759628 24.188H-726.769C-727.911 11.7988 -737.81 1.89927 -750.198 0.757771V-494.768Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1005_6968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "matrix(-1 0 0 -1 29 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordercruve4);
export default __webpack_public_path__ + "static/media/bordercruve4.3247dbfa68ffcb096776c7a160c0d30e.svg";
export { ForwardRef as ReactComponent };